import React, { useCallback } from "react";
import { Checkbox, FormControlLabel, makeStyles } from "@material-ui/core";

const useFormControlStyles = makeStyles({
  root: {
    margin: 0,
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
});

const useCheckboxStyles = makeStyles({
  root: {
    padding: 0,
  },
});

function ICheckbox({ label, checked, onChanged }) {
  const formControlClasses = useFormControlStyles();
  const checkboxClasses = useCheckboxStyles();

  const [state, setState] = React.useState(checked);
  const handleChanged = useCallback(
    (_, state) => {
      setState(state);
      if (onChanged instanceof Function) {
        onChanged(state);
      }
    },
    [onChanged]
  );

  return (
    <FormControlLabel
      classes={formControlClasses}
      control={
        <Checkbox
          classes={checkboxClasses}
          checked={state}
          onChange={handleChanged}
          color="primary"
          size="small"
        />
      }
      label={label}
    />
  );
}

export default ICheckbox;
